import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "@/utils/hooks/useMutationWithError";
import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import {
  CreateGiftCardInput,
  useCreateGiftCardMutation,
} from "./__generated__/useCreateGiftCardMutation.graphql";

export const useCreateGiftCard = (callback: (giftCardId: string) => void) => {
  const [createGiftCard, isCreatingGiftCard] =
    useMutationWithError<useCreateGiftCardMutation>(
      useCreateGiftCardMutationString
    );
  const { showToast } = useToast();

  const handleCreateGiftCard = (input: CreateGiftCardInput) => {
    createGiftCard({
      variables: { input },
      onCompleted: (response) => {
        if (response.responsePayload?.success) {
          callback(response.responsePayload?.squareGiftCard?.id ?? "");
        }
        showToast({
          description: t`Gift Card Added Successfully!`,
          semanticStyle: "success",
          toastId: "create-gift-card-success",
        });
      },
      onErrorCustom: () => {
        showToast({
          description: t`Unable to add gift card. Please try again.`,
          semanticStyle: "error",
        });
      },
    });
  };
  return [handleCreateGiftCard, isCreatingGiftCard] as const;
};

export const useCreateGiftCardMutationString = graphql`
  mutation useCreateGiftCardMutation($input: CreateGiftCardInput!) {
    responsePayload: createGiftCard(input: $input) {
      success
      errors {
        field
        code
        message
      }
      customer {
        ...GiftCardsList_customer
      }
      squareGiftCard {
        id
      }
    }
  }
`;
